'use client';

import { cn } from '@core/utils';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

interface SymptomCodeListProps {
  symptomCodeList: string[];
}

const SymptomCodeItems = ({
  symptomCodeList,
  highlightCodeList = [],
}: SymptomCodeListProps & { highlightCodeList?: string[] }) => (
  <ul className="flex flex-1 flex-wrap gap-4">
    {symptomCodeList.map((symptomCode, index) => (
      <li
        key={symptomCode}
        className={cn('text-Gray-800 typo-body4', {
          'after:content-[","]': index !== symptomCodeList.length - 1,
          'text-B-500': highlightCodeList.some((emergencyRoomCode) =>
            symptomCode.includes(emergencyRoomCode),
          ),
        })}
      >
        {symptomCode}
      </li>
    ))}
  </ul>
);

const SearchParamAwareSymptomCodeList = ({
  symptomCodeList,
}: SymptomCodeListProps) => {
  const searchParams = useSearchParams();
  const rawSymptomCode = searchParams.get('symptomCode');

  let highlightCodeList: string[] = [];
  try {
    if (rawSymptomCode) highlightCodeList = JSON.parse(rawSymptomCode);
  } catch {
    // 잘못된 쿼리 파라미터는 하이라이트 없이 렌더한다.
  }

  return (
    <SymptomCodeItems
      symptomCodeList={symptomCodeList}
      highlightCodeList={highlightCodeList}
    />
  );
};

// useSearchParams를 자체 Suspense로 감싸 페이지 전체의 CSR bailout을 막는다.
export const SymptomCodeList = ({ symptomCodeList }: SymptomCodeListProps) => (
  <Suspense fallback={<SymptomCodeItems symptomCodeList={symptomCodeList} />}>
    <SearchParamAwareSymptomCodeList symptomCodeList={symptomCodeList} />
  </Suspense>
);
